<template>
  <div class="wrap">
    <!-- <Nav title="设备服务" /> -->
    <div class="bottom-info1">
      <div class="text-section">
        <h1>驻场服务</h1>
      </div>
      <div class="icon-container">
        <img src="@/assets/other/gongchengshi/kapian.jpg" alt="" />
      </div>


      <div class="liaojiebtn">
        <a href="#" class="anniubtn">
          了解详情
        </a>
      </div>
    </div>

    <br />
    <div class="leasing-container">
      <div class="text-section">
        <h1>实施服务</h1>
      </div>
      <div class="content-row">
        <div class="text-content">
          <ul>
            <li><img
                src="@/assets/other/element/dian.png">鹏海信息通过标准化的流程、专业的工程师团队和高效的项目管理工具，提供涵盖基础网络架构、无线网络、数据中心等多场景的设备安装调试服务。
            </li>
            <li style="align-items: left;"><img src="@/assets/other/gongchengshi/duoimg.png"
                style="object-fit: contain; height: 202px;width: 616px; align-items: left;"></li>
          </ul>
        </div>
        <div class="image-content tu1">
          <img src="@/assets/other/gongchengshi/you.png" alt="">
        </div>
      </div>

      <div class="content-row reverse">
        <div class="text-content">
          <h2 style="margin-left: 0%;">为客户带来的价值</h2>
          <ul>
            <li><img src="@/assets/other/element/dian.png">规范化：采用行业最佳实践，确保项目实施过程规范、可靠，为后续运维与扩展提供稳定的基础。</li>
            <li><img src="@/assets/other/element/dian.png">高效率：通过精细化的项目管理和流程工具，确保项目按时、按预算完成，优化资源配置，减少浪费。</li>
            <li><img src="@/assets/other/element/dian.png">低风险：通过严格的风险管理流程，实施过程中对潜在风险进行识别与监控，确保项目风险降至最低。</li>
          </ul>
        </div>
        <div class="image-content tu2">
          <img src="@/assets/other/gongchengshi/zuo.png" alt="">
        </div>
      </div>
      <div class="lc">
        <img src="@/assets/other/gongchengshi/shishiliucheng.png" alt="" />
      </div>
    </div>
  </div>
  <!-- <Footer :show="true" /> -->
  </div>
</template>



<script>
  import {
    getWorkList,
    getWorkYearList,
    getProductListAll
  } from "@/api/api.js";
  import Nav from "../../components/Nav/Nav.vue";
  export default {
    name: "index",
    components: {
      Nav
    },
    data() {
      return {
        jsonData: [],
        imgList: [],
        url: "/Work",
        pageSize: 100,
        currentPage: 1,
        total: 0,
        activeIndex: "1",
        paramsYear: {
          workCompetition: this.$route.query.key
        }
      };
    },
    methods: {
      getProductListAll() {
        getProductListAll({
          state: "Y"
        }).then(res => {
          this.jsonData = res.data.rows || [];
          console.log(res);
        });
      },
      getList() {
        getWorkList({}).then(res => {
          // this.imgList = res.data || [];
          console.log(res);
        });
      },
      getWorkYearList(paramsYear) {
        getWorkYearList(paramsYear).then(res => {
          this.imgList = res.data.rows || [];

          console.log(res);
        });
      },
      handleSelect(index) {
        console.log(index);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
      },
      toPage(item, index) {
        this.$router.push({
          path: "Work/wordDetail",
          query: {
            id: index,
            title: item.workTitle,
            info: item
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  * {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .shi {
    margin-top: 8%;
  }

  .liaojiebtn {
    margin-top: 6%;
  }

  .anniubtn:hover {
    background: rgba(218, 41, 28, 1);
    display: flex;
    color: white;
  }

  .anniubtn:active {
    transform: scale(0.98);
    /* 点击时轻微缩小 */
  }

  .anniubtn {
    white-space: nowrap;
    /* 禁止文字换行 */
    transition: all 0.3s ease;
    /* 平滑过渡动画 */
    text-decoration: none;
    background-color: white;
    text-align: center;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    width: 156px;
    height: 56px;
    opacity: 1;
    border-radius: 9px;
    color: rgba(218, 41, 28, 1);
    border: 1px solid rgba(218, 41, 28, 1);
    display: flex;
    padding: 10px 40px 10px 40px;
    font-size: 18px;
    letter-spacing: 0px;
    line-height: 32px;
  }









  .tu1 {
    margin-right: -200px;
  }

  .tu2 {
    margin-left: -30px;
  }

  .text-content li {
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 1.1px;
    line-height: 50px;
    color: rgba(103, 103, 103, 1);
  }

  .leasing-container ul li img {
    width: 10px;
    height: 10px;
    object-fit: contain;
    margin-top: 20px;
    margin-right: 15px;
  }

  .leasing-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 40px 20px;
  }

  .content-row {
    display: flex;
    align-items: center;
    margin-bottom: 60px;
  }

  /* 默认布局：文字左，图片右 */
  .text-content {
    flex: 1;
    padding-right: 40px;
  }

  .image-content {
    flex: 1;
  }

  .image-content img {
    width: 553.21px;
    height: 418px;
    opacity: 1;
    display: flex;
  }

  /* 反向布局：图片左，文字右 */
  .reverse {
    flex-direction: row-reverse;
  }

  .reverse .text-content {
    padding-right: 0;
    padding-left: 40px;
  }

  .text-content h2 {
    margin-left: 30px;
    font-family: "思源黑体";
    font-size: 40px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 80px;
    color: rgba(0, 146, 214, 1);
    text-align: left;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
  }

  li {
    position: relative;
    padding-left: 30px;
    margin-bottom: 15px;
    line-height: 1.6;
    color: #444;
  }

  // li::before {
  //   content: "•";
  //   color: #2363c5;
  //   font-size: 24px;
  //   position: absolute;
  //   left: 0;
  //   top: -3px;
  // }

  /* 响应式设计 */
  @media (max-width: 768px) {

    .content-row,
    .reverse {
      flex-direction: column;
    }

    .text-content {
      padding: 0 20px 20px !important;
    }

    .image-content {
      margin-top: 20px;
    }
  }

  .zupng h1 {
    padding-top: 200px;
    font-size: 44px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 55.5px;
    color: rgba(46, 49, 51, 1);
    text-align: center;
    vertical-align: top;
  }

  .zupingbox p {
    padding-top: 40px;
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 32px;
    color: rgba(103, 106, 108, 1);
    text-align: center;
    vertical-align: top;
  }

  .zupingbox {
    max-width: 1440px;
    height: 100%;
    margin: 0 auto;
    padding: 30px;
    font-family: "Microsoft YaHei", sans-serif;
    background-color: #fff;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .xiantiao {
    width: 1440px;
    height: 1019px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 1795px;
    object-fit: cover;
    /* 保持比例填充 */
    object-position: center;
    /* 居中显示 */
    pointer-events: none;
    /* 防止交互影响 */
    /* 向上移动30px */

  }

  .xiantiao img {
    display: block;
    max-width: 100%;
    z-index: 2;
    object-fix: contain;
  }

  .bottom-info1 {
    max-width: 1440px;
    margin: 0 auto;
    padding: 30px;
    font-family: "Microsoft YaHei", sans-serif;
    background-color: #fff;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .text-section h1 {
    margin-bottom: 20px;
    font-size: 44px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 55.5px;
    color: rgba(46, 49, 51, 1);
    text-align: center;
    vertical-align: top;
  }

  .text-section p {
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 32px;
    color: rgba(103, 106, 108, 1);
    text-align: center;
    vertical-align: top;
  }

  .icon-container {
    width: 100%;
    display: grid;
    place-items: center;
    /* 单行代码实现居中 */

  }

  .icon-container img {
    object-fit: contain;
    margin-top: 50px;
    height: 400px;
    opacity: 1;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .banner {
    width: 1440px;
    // margin-top: 82px;
    position: relative;
    overflow: hidden;
    justify-content: center;
    align-items: center;
  }

  .hanner img {
    object-fit: cover;
    object-position: center;
  }

  .content {
    margin-top: 20px;

    .type {
      margin-top: 50px;

      .title {
        position: relative;
        width: 200px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        background-color: #5197d5;
        color: #fff;

        .line {
          display: inline-block;
          position: absolute;
          top: 22px;
          left: 20px;
          width: 15px;
          height: 3px;
          background-color: #fff;
        }
      }

      .bottom-info {
        display: flex;
        // flex-wrap: wrap;
        justify-content: stretch;

        .item {
          height: 350px;
          border: 2px solid #5197d5;
          margin-top: 20px;
          margin-right: 50px;

          img {
            width: 250px;
            height: 200px;
            margin: 0 30px;
          }

          .txt {
            width: 310px;
            height: 100px;
            margin-top: 50px;
            padding-top: 5px;
            line-height: 30px;
            font-size: 18px;
            text-align: center;
            background-color: #5197d5;
            color: #fff;
          }
        }
      }
    }
  }

  .select {
    height: 80px;
    width: 60%;
    margin: 0 auto;
  }

  .el-menu-item.is-active {
    border-bottom: 2px solid red !important;
    color: red !important;
    font-weight: bold;
  }

  .el-menu-item {
    padding: 0 43px;
  }

  .page {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }

  .img-title {
    text-align: center;
  }

  .wrap {
    text-align: left;
    width: 100%;
    height: 100%;
    position: relative;

    .banner {
      width: 100%;
      z-index: -2;
    }

    .imgbox {
      .box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .boxitem {
          width: 25%;
          padding-bottom: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .onde {
            width: 90%;
            height: 320px;

            .top {
              position: relative;

              .ditu {
                width: 100%;
                height: 45px;
                line-height: 45px;
                text-align: center;
                top: 175px;
                color: #ffffff;
                font-size: 14px;
                position: absolute;
                background: url("../../assets/workimg/ditu.png") no-repeat;
                background-position: center;
              }
            }

            .cont {
              font-size: 14px;
              text-align: center;
              background-color: #f5f5f5;
              padding: 20px 0;
            }

            .bottom {
              width: 100%;
              background-color: #f5f5f5;
              padding: 10px 0;
              display: flex;
              font-size: 14px;
              justify-content: space-around;
              align-items: center;

              div {
                // width: 50%;
                text-align: right;
                // padding-right: 10px;
              }
            }
          }
        }

        .boxitem:hover {
          border-bottom: 1px solid red;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Work/gongchengshi.vue